export type SwMessage = { type: "SKIP_WAITING" };

export const SW_URL = "/sw.js";
export const SW_SCOPE = "/";

export function postSkipWaiting(worker: ServiceWorker | null): void {
  if (!worker) return;
  worker.postMessage({ type: "SKIP_WAITING" } satisfies SwMessage);
}
